/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestApplicantToken_requestApplicantToken_Auth = { readonly __typename: 'Auth', readonly token: string };

export type RequestApplicantToken_Mutation = { readonly __typename: 'Mutation', readonly requestApplicantToken: RequestApplicantToken_requestApplicantToken_Auth | null };


export type RequestApplicantTokenVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
  skipEmails?: _Types.InputMaybe<_Types.Scalars['Boolean']['input']>;
}>;


export type RequestApplicantToken = RequestApplicantToken_Mutation;


export const RequestApplicantTokenDocument = gql`
    mutation RequestApplicantToken($salesforceCreditId: ID!, $skipEmails: Boolean) {
  requestApplicantToken(
    creditApplicationId: $salesforceCreditId
    skipEmails: $skipEmails
  ) {
    token
  }
}
    `;
export type RequestApplicantTokenMutationFn = Apollo.MutationFunction<RequestApplicantToken, RequestApplicantTokenVariables>;

/**
 * __useRequestApplicantToken__
 *
 * To run a mutation, you first call `useRequestApplicantToken` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApplicantToken` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApplicantToken, { data, loading, error }] = useRequestApplicantToken({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      skipEmails: // value for 'skipEmails'
 *   },
 * });
 */
export function useRequestApplicantToken(baseOptions?: Apollo.MutationHookOptions<RequestApplicantToken, RequestApplicantTokenVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApplicantToken, RequestApplicantTokenVariables>(RequestApplicantTokenDocument, options);
      }
export type RequestApplicantTokenHookResult = ReturnType<typeof useRequestApplicantToken>;
export type RequestApplicantTokenMutationResult = Apollo.MutationResult<RequestApplicantToken>;
export type RequestApplicantTokenMutationOptions = Apollo.BaseMutationOptions<RequestApplicantToken, RequestApplicantTokenVariables>;